import React, { Component } from "react";
import { connect } from "react-redux";

import { createPermission } from "actions/permission";
import { toggleFullPageSpinner, toggleNotification } from "actions/toggle";

import Form from "pages/Permission/Form";

class PermissionCreate extends Component {
  handleFormSubmit = data => {
    this.createPermission(data);
  };

  createPermission(data) {
    const { toggleNotification, toggleFullPageSpinner, createPermission, history } = this.props;
    toggleFullPageSpinner(true);
    createPermission(data)
      .then(() => {
        toggleNotification(true, { message: "Created Permission Success", infoClassName: "is-success" });
        history.push(`/permissions`);
      })
      .catch(e => {
        toggleNotification(true, { message: e.message, infoClassName: "is-danger" });
      })
      .then(() => toggleFullPageSpinner(false));
  }

  render() {
    return <Form handleFormSubmit={this.handleFormSubmit} />;
  }
}

export default connect(
  null,
  {
    createPermission,
    toggleFullPageSpinner,
    toggleNotification
  }
)(PermissionCreate);



// WEBPACK FOOTER //
// ./src/pages/Permission/Create/index.js